import React from 'react'

const HistoryQuestions = () => {
    return (
        <div className="background">
            <div className="background__circle"></div>
            <div className="background__shadow-center"></div>
            <div className="background__shadow-left"></div>
            <div className="background__clouds-wrapper">
                <div className="background__cloud"></div>
                <div className="background__cloud"></div>
            </div>
        </div>
    )
}

export default HistoryQuestions
